import { NavLink } from "react-router-dom";
import { LineChart, Sprout, Users, BarChart3, Activity } from "lucide-react";

const ITEMS = [
    { to: "/dashboard", label: "Founders", icon: LineChart, enabled: true, key: "founders" },
    { to: "/suppliers", label: "Suppliers", icon: Sprout, enabled: true, key: "suppliers" },
    { to: "/users", label: "Users", icon: Users, enabled: true, key: "users" },
    { to: "/demand", label: "Demand", icon: BarChart3, enabled: true, key: "demand" },
    { to: "/health", label: "Health", icon: Activity, enabled: true, key: "health" },
];

export default function MobileNav() {
    return (
        <nav
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 hg-glass border-t border-white/5 flex items-stretch justify-around px-2 py-2"
            data-testid="mobile-nav"
        >
            {ITEMS.map(({ to, label, icon: Icon, enabled, key }) =>
                enabled ? (
                    <NavLink
                        key={key}
                        to={to}
                        end
                        className={({ isActive }) =>
                            `flex-1 flex flex-col items-center gap-1 py-1.5 ${
                                isActive ? "" : "opacity-70"
                            }`
                        }
                        data-testid={`mobile-nav-${key}`}
                    >
                        {({ isActive }) => (
                            <>
                                <Icon
                                    size={18}
                                    className={isActive ? "text-[#22C55E]" : "text-[#A1A1AA]"}
                                    style={
                                        isActive
                                            ? {
                                                  filter:
                                                      "drop-shadow(0 0 6px rgba(34,197,94,0.9))",
                                              }
                                            : undefined
                                    }
                                />
                                <span
                                    className={`font-mono-data text-[9px] uppercase tracking-widest ${
                                        isActive
                                            ? "text-[#FAFAFA]"
                                            : "text-[#71717a]"
                                    }`}
                                >
                                    {label}
                                </span>
                            </>
                        )}
                    </NavLink>
                ) : (
                    <div
                        key={key}
                        className="flex-1 flex flex-col items-center gap-1 py-1.5 opacity-30"
                        data-testid={`mobile-nav-${key}`}
                    >
                        <Icon size={18} className="text-[#52525b]" />
                        <span className="font-mono-data text-[9px] uppercase tracking-widest text-[#52525b]">
                            {label}
                        </span>
                    </div>
                ),
            )}
        </nav>
    );
}
